import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { profileColors } from '../profileConstants';
import Smiley from './Smiley';
import { setEditedProfile } from '../../../redux/applicationSlice';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import CloseSmileySelectorButton from './closeSmileySelectorButton';

const SmileySelector = ({
    showSmileySelector,
    setShowSmileySelector
}) => {
    const dispatch = useDispatch();
    const { editedProfile, theme } = useSelector((state) => state.application);
    const { ref, focusSelf } = useFocusable({
        focusKey: "smileySelector",
        isFocusBoundary: true,
        trackChildren: true,
        autoRestoreFocus: true,
    });
    useEffect(() => {
        if (showSmileySelector) focusSelf();
    }, [showSmileySelector]);
    return (
        <FocusContext.Provider value={"smileySelector"}>
            <div ref={ref} className={`smileySelector ${!showSmileySelector && 'hidden'}`} style={{ backgroundColor: theme?.general?.bgColor ?? "#000000", color: theme?.general?.color }}>
                <p>
                    Choose Smiley Face
                    <CloseSmileySelectorButton setShowSmileySelector={setShowSmileySelector} />
                </p>
                <div className='smileySelectorContent' style={{ backgroundColor: theme?.general?.bgColor ?? "#000000", color: theme?.general?.color }}>
                    {profileColors.map((color, index) => {
                        return <Smiley size='140px' profile={{ Avatar: index }} key={index} onClick={() => {
                            dispatch(setEditedProfile({ ...editedProfile, Avatar: index }));
                            setShowSmileySelector(false)
                        }} />;
                    })}
                </div>
            </div>
        </FocusContext.Provider>
    );
}

export default SmileySelector;
